import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { ProjectilePool } from './ProjectilePool';

const CHAINGUN_CONFIG: WeaponConfig = {
  name: 'Chain Gun',
  damage: 10,
  fireRate: 15, // 15 shots per second (fast!)
  projectileSpeed: 200,
  ammoMax: 200,
  reloadTime: 3,
  spread: 0.08, // Less accurate
  automatic: true,
  projectileColor: new THREE.Color(0xff00ff),
  projectileSize: 0.08,
};

export class ChainGun extends Weapon {
  private projectilePool: ProjectilePool;

  constructor(projectilePool: ProjectilePool) {
    super(CHAINGUN_CONFIG);
    this.projectilePool = projectilePool;
  }

  protected createProjectile(origin: THREE.Vector3, direction: THREE.Vector3): void {
    this.projectilePool.spawn(
      origin,
      direction,
      this.getEffectiveProjectileSpeed(),
      this.getEffectiveDamage(),
      this.config.projectileColor,
      1.5 // Shorter lifetime
    );
  }
}
